var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('home-hero-banner'),_vm._v(" "),_c('location-box'),_vm._v(" "),_c('opening-times-box'),_vm._v(" "),_c('contact-box')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }